/* eslint-disable @typescript-eslint/ban-types */
// Copyright IBM Corp. 2018. All Rights Reserved.
// Node module: openapi-to-graphql
// This file is licensed under the MIT License.
// License text available at https://opensource.org/licenses/MIT
export var GraphQLOperationType;
(function (GraphQLOperationType) {
    GraphQLOperationType[GraphQLOperationType["Query"] = 0] = "Query";
    GraphQLOperationType[GraphQLOperationType["Mutation"] = 1] = "Mutation";
    GraphQLOperationType[GraphQLOperationType["Subscription"] = 2] = "Subscription";
})(GraphQLOperationType || (GraphQLOperationType = {}));
//# sourceMappingURL=graphql.js.map